import 'antd/dist/antd.css';
import 'bootstrap/dist/css/bootstrap.css';
import { useRouter } from 'next/router';
import * as React from 'react';
import styles from './footer.module.css';
import { useSelector } from 'react-redux';

function Footer() {
  const routers = useRouter();
  const { user } = useSelector((state) => state.user);
  const showFooter =
    routers.pathname === '/' ||
    ((user === null || user === '') && routers.pathname === '/support')
      ? true
      : false;

  return (
    <>
      {showFooter ? (
        <footer className={`${styles.footer} w-100`}>
          <div className="row py-3">
            <div className={`col-lg-5 col-sm ${styles.FooterMenuclass}`}>
              <ul className="list-inline small d-flex flex-wrap d-lg-block mb-lg-0 mb-md-0">
                <li className="list-inline-item col-4 col-md-2 col-lg-3 w-auto mr-0 mr-lg-3 mb-2 mb-lg-0 p-0">
                  <a
                    className="text-white label"
                    href="https://www.celcom.com.my/legal/disclaimer"
                  >
                    Disclaimer
                  </a>
                </li>
                <li className="list-inline-item col-4 col-md-2 col-lg-3 w-auto mr-0 mr-lg-3 mb-2 mb-lg-0 p-0">
                  <a
                    className="text-white label"
                    onClick={() => {
                      routers.push({ pathname: '/support', query: { tab: 1 } });
                    }}
                  >
                    Help Center
                  </a>
                </li>
                <li className="list-inline-item col-4 col-md-2 col-lg-3 w-auto mr-0 mr-lg-3 mb-2 mb-lg-0 p-0">
                  <a
                    className="text-white label"
                    href="https://www.celcom.com.my/legal/fair-usage-policy"
                  >
                    Fair Usage Policy
                  </a>
                </li>
                <li className="list-inline-item col-4 col-md-2 col-lg-3 w-auto mr-0 mr-lg-3 mb-2 mb-lg-0 p-0">
                  <a
                    className="text-white label"
                    href="https://www.celcom.com.my/legal/privacy-matters"
                  >
                    Privacy Notice
                  </a>
                </li>
                <li className="list-inline-item col-4 col-md-2 col-lg-3 w-auto mr-0 mr-lg-3 mb-2 mb-lg-0 p-0">
                  <a
                    className="text-white label"
                    href="https://www.celcom.com.my/legal/speak-up"
                  >
                    Speak up
                  </a>
                </li>
                <li className="list-inline-item col-4 col-md-2 col-lg-3 w-auto mr-0 mr-lg-3 mb-2 mb-lg-0 p-0">
                  <a
                    className="text-white label"
                    href="https://www.celcom.com.my/legal/terms-and-conditions"
                  >
                    Terms &amp; Conditions
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-7 col-sm">
              <p
                className="float-lg-right label mb-0"
                style={{ color: '#CCCCCC' }}
              >
                Copyright 2024 CelcomDigi Berhad (Formerly known as Digi.com
                Berhad) [Registration No. 199701009694(425190-X)]. All Rights
                Reserved.
              </p>
            </div>
          </div>
        </footer>
      ) : (
        <footer className={`${styles.footer} w-100`}>
          <div className="row py-3">
            <div className={`col-lg-5  col-sm${styles.FooterMenuclass}`}>
              <ul className="list-inline small d-flex flex-wrap d-lg-block mb-lg-0 mb-md-0">
                <li className="list-inline-item col-4 col-md-2 col-lg-3 w-auto mr-0 mr-lg-3 mb-2 mb-lg-0 p-0">
                  <a
                    className="text-white label"
                    href="https://www.celcom.com.my/legal/disclaimer"
                  >
                    Disclaimer
                  </a>
                </li>
                <li className="list-inline-item col-4 col-md-2 col-lg-3 w-auto mr-0 mr-lg-3 mb-2 mb-lg-0 p-0">
                  <a
                    className="text-white label"
                    href="https://www.celcom.com.my/legal/fair-usage-policy"
                  >
                    Fair Usage Policy
                  </a>
                </li>
                <li className="list-inline-item col-4 col-md-2 col-lg-3 w-auto mr-0 mr-lg-3 mb-2 mb-lg-0 p-0">
                  <a
                    className="text-white label"
                    href="https://www.celcom.com.my/legal/privacy-matters"
                  >
                    Privacy Notice
                  </a>
                </li>
                <li className="list-inline-item col-4 col-md-2 col-lg-3 w-auto mr-0 mr-lg-3 mb-2 mb-lg-0 p-0">
                  <a
                    className="text-white label"
                    href="https://www.celcom.com.my/legal/speak-up"
                  >
                    Speak up
                  </a>
                </li>
                <li className="list-inline-item col-4 col-md-2 col-lg-3 w-auto mr-0 mr-lg-3 mb-2 mb-lg-0 p-0">
                  <a
                    className="text-white label"
                    href="https://www.celcom.com.my/legal/terms-and-conditions"
                  >
                    Terms &amp; Conditions
                  </a>
                </li>
              </ul>
            </div>
            <div className={`col-lg-7 col-sm ${styles.FooterMobile}`}>
              <p
                className="float-lg-right label mb-0"
                style={{ color: '#CCCCCC' }}
              >
                Copyright 2024 CelcomDigi Berhad (Formerly known as Digi.com
                Berhad) [Registration No. 199701009694(425190-X)]. All Rights
                Reserved.
              </p>
            </div>
          </div>
        </footer>
      )}
    </>
  );
}

export default Footer;
